'use client';
import { Box } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { useFloatingCTA } from '@/hooks/floating-cta.hook';
import { NewCarData } from '@/types/new-cars/new-cars.types';

import HeaderBar from './HeaderBar';
import VariantsModels from './VariantsModels';

export type SpecificationType = Record<string, Record<string, string | boolean>>;
export type CompareModelsProps = {
  model: string;
  newVehicle: NewCarData;
  panelDetails: Record<string, SpecificationType>;
  selectedSpecification: NewCarData['specification_prices'];
};

const CompareModelsPage = ({
  model,
  newVehicle,
  panelDetails,
  selectedSpecification,
}: CompareModelsProps) => {
  const newModel = model.toString().toLowerCase().replace('kia-', '');

  const { setFormItem } = useFloatingCTA();

  useEffect(() => {
    setFormItem({
      type: 'new-car',
      newCar: newVehicle,
    });
    return () => {
      setFormItem(undefined);
    };
  }, [newVehicle]);

  return (
    <Box>
      <HeaderBar modelName={newModel} />
      <Box overflowX={'auto'} width={'100%'} mb={{ base: 4, lg: 0 }}>
        <VariantsModels
          specificationsPrices={selectedSpecification}
          allSpecificationsPrices={newVehicle?.specification_prices}
          modelName={newModel}
          specifications={panelDetails}
        />
      </Box>
    </Box>
  );
};

export default CompareModelsPage;
